import React from 'react';
import styled from 'styled-components';
import {
  InfoOutlined,
  HowToRegOutlined,
  ShareOutlined,
  SecurityOutlined,
  VpnKeyOutlined,
  SyncOutlined,
  EmailOutlined
} from '@mui/icons-material';

const PageContainer = styled.div`
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
  font-family: '"Proxima Nova"', sans-serif;
  line-height: 1.6;
`;

const Heading = styled.h1`
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const Section = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 40px;
`;

const IconWrapper = styled.div`
  margin-right: 25px;
  color: #007bff;
  margin-top: -5px; /* Align icon better with text */
`;

const SectionContent = styled.div`
  flex: 1;
`;

const SectionTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 10px;
`;

const Privacy = () => {
  return (
    <PageContainer>
      <Heading>Privacy Policy</Heading>
      <p><strong>Last updated:</strong> June 10, 2025</p>

      <p>
        Vaidhyamegha Pvt. Ltd. ("us", "we", or "our") operates the DevOps Buddy dashboard (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
      </p>

      <Section>
        <IconWrapper><InfoOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Information Collection and Use</SectionTitle>
          <p>We collect several different types of information for various purposes to provide and improve our Service to you. This may include, but is not limited to, your email address, name, and usage data.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><HowToRegOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>How We Use Your Information</SectionTitle>
          <p>We use the collected data for various purposes:</p>
          <ul>
            <li>To provide and maintain our Service</li>
            <li>To notify you about changes to our Service</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information so that we can improve our Service</li>
            <li>To monitor the usage of our Service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><ShareOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Data Sharing and Disclosure</SectionTitle>
          <p>We do not sell or rent your personal data to third parties. We may share your information with third-party service providers to facilitate our Service, but they are obligated not to disclose or use it for any other purpose.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><SecurityOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Data Security</SectionTitle>
          <p>The security of your data is important to us. We use industry-standard encryption and security best practices to protect your data. However, remember that no method of transmission over the Internet or method of electronic storage is 100% secure.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><VpnKeyOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Your Data Protection Rights</SectionTitle>
          <p>You have the right to access, update, or delete the information we have on you. You can do this through your account settings or by contacting us directly.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><SyncOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Changes to This Privacy Policy</SectionTitle>
          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>
        </SectionContent>
      </Section>
      
      <Section>
        <IconWrapper><EmailOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>Contact Us</SectionTitle>
          <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:privacy@vaidhyamegha.com">privacy@vaidhyamegha.com</a>.</p>
        </SectionContent>
      </Section>
    </PageContainer>
  );
};

export default Privacy;
